import { input } from '../../tokens/component';
import { state, effects } from '../../tokens/semantic';

const { radio } = input.selection;

const MuiRadio = {
    defaultProps: {
        size: 'medium',
    },
    styleOverrides: {
        root: {
            color: radio.color.off.default,
            '&:hover': {
                color: radio.color.off.hover,
                backgroundColor: 'transparent',
            },
            '&.Mui-checked': {
                color: radio.color.on.default,
                '&:hover': {
                    color: radio.color.on.hover,
                    backgroundColor: 'transparent',
                },
            },
            '&.Mui-focusVisible .MuiSvgIcon-root': {
                outline: `${state.outline.weight.focus.md} solid ${state.outline.color.focus}`,
                outlineOffset: state.outline.offset.focus.sm,
                borderRadius: effects.radius.full,
            },
            '&.Mui-disabled': {
                opacity: radio.state.disabled.opacity,
            },
        },
        sizeSmall: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
                fontSize: radio.size.sm,
            },
            [theme.breakpoints.down('sm')]: {
                '& .MuiSvgIcon-root': {
                    fontSize: radio.size.lg,
                },
            },
        }),
    },
    variants: [
        {
            props: { size: 'medium' },
            style: ({ theme }) => ({
                '& .MuiSvgIcon-root': {
                    fontSize: radio.size.md,
                },
                [theme.breakpoints.down('sm')]: {
                    '& .MuiSvgIcon-root': {
                        fontSize: radio.size.lg,
                    },
                },
            }),
        },
        {
            props: { size: 'large' },
            style: {
                '& .MuiSvgIcon-root': {
                    fontSize: radio.size.lg,
                },
            },
        },
    ],
};

export default MuiRadio;
